<template>
  <div class="pt-4">
    <div>
      <v-list three-line class="full-height pb-8">
        <!-- Dark / Light Mode switch -->
        <v-list-item @click="dark = !dark" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('toggleTheme') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('toggleTheme.description') }}</v-list-item-subtitle>

            <v-list-item-subtitle>{{ $t('toggleTheme.currentMode') }} "{{ dark ? $t('theme.dark') : $t('theme.light') }}" </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <morph-icon
              :size="30"
              :color="darkMode ? 'white' : 'black'"
              to-icon="mdi-invert-colors"
              from-icon="mdi-invert-colors-off"
              :trigger="dark"
            ></morph-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- Font-size -->
        <v-list-item class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings.fontSize') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('fontSize.change') }}</v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip-group v-model="baseFontSize" column>
                <v-chip v-for="fontSize in fontSizes" :key="fontSize.text" :value="fontSize.value" outlined>
                  {{ fontSize.text }}
                </v-chip>
              </v-chip-group>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-format-font-size-increase</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="configs && configs.languageKeys && configs.languageKeys.length > 1" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('lang.settings') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <language-selector></language-selector>
            </v-list-item-subtitle>
            <!--            <v-btn-toggle mandatory v-model="language" :color="theme.elements.activeColor">-->
            <!--              <v-btn small v-for="lang in configs && configs.languageKeys" :key="lang" @click="selectLang(lang)">-->
            <!--                <div v-if="lang.length > 1">-->
            <!--                  {{ lang }}-->
            <!--                </div>-->
            <!--              </v-btn>-->
            <!--            </v-btn-toggle>-->
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-translate</v-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- PDF Viewer Settings -->
        <v-list-item v-if="features.pdfViewerSwitchEnabled" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings.pdfViewer') }}</v-list-item-title>
            <v-list-item-subtitle class="pt-2">{{ $t('settings.pdfViewerDescription') }}</v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip-group active-class="i-primary" mandatory v-model="displayPdfViewerHintMode">
                <v-chip filter outlined value="display">immer</v-chip>
                <v-chip filter outlined value="button">orange Linie oben</v-chip>
                <v-chip filter outlined value="none"> nie</v-chip>
              </v-chip-group>
              <v-list-item-subtitle class="pt-2">PDF Viewer</v-list-item-subtitle>

              <v-chip-group active-class="align-center" mandatory v-model="pdfViewer">
                <v-chip filter outlined value="pdfjs">Standard</v-chip>
                <v-chip filter outlined value="pdfjsexpress">Alternativen Viewer</v-chip>
              </v-chip-group>
              <!--              <v-checkbox class="ml-2" v-model="displayPdfChangeViewer" :label="$t('settings.pdfViewerHint')"></v-checkbox>-->
            </v-list-item-subtitle>
            <!--                    <v-list-item-subtitle>-->
            <!--                      <v-chip-group v-model="pdfViewer" style="width: 100%; overflow: hidden">-->
            <!--                        <v-chip outlined filter value="pdfjs">Standard</v-chip>-->
            <!--                        <v-chip outlined filter value="pdfjsexpress">Alternative</v-chip>-->
            <!--                        <v-chip outlined filter value="desktopembedded">Download</v-chip>-->
            <!--                      </v-chip-group>-->
            <!--                    </v-list-item-subtitle>-->
          </v-list-item-content>
        </v-list-item>
        <!-- Time Format-->
        <v-list-item v-if="features.isTimeFormatSettingEnabled === undefined || features.isTimeFormatSettingEnabled === true" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings.timeFormat') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('hourFormat.description') }}</v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip-group v-model="timeFormatSetting" column>
                <v-chip filter v-for="timeFormat in timeFormats" :key="timeFormat.value" :value="timeFormat.value" outlined>{{ timeFormat.text }} </v-chip>
              </v-chip-group>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-clock-outline</v-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- Reload App -->
        <v-list-item v-if="isConnected" @click="reload" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings.reloadApp') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('app.reload') }}</v-list-item-subtitle>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-reload</v-icon>
          </v-list-item-action>
        </v-list-item>

        <!-- Reset App -->
        <v-list-item v-if="isConnected" @click="resetAppDialogOpen = true" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings.resetApp') }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('app.reset.details') }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-power</v-icon>
          </v-list-item-action>
        </v-list-item>

        <!-- ChangePassword -->
        <v-list-item v-if="isConnected && features.passwordChangeLink" @click="showChangePassword" class="item-bottom-border">
          <v-list-item-content>
            <v-list-item-title>{{ $t('login.changePassword') }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-reset</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>

    <reset-app-dialog
      :title="$t('settings.resetApp.title')"
      :text="$t('settings.resetApp.info')"
      @onClose="resetAppDialogOpen = false"
      :isOpen="resetAppDialogOpen"
    ></reset-app-dialog>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import MorphIcon from '../icons/MorphIcon.vue';
import ResetAppDialog from './ResetAppDialog.vue';
import { mapMutations, mapState } from 'vuex';
import LanguageSelector from '@/components/LanguageSelector.vue';
import configurations from '@/common/config';
export default {
  mixins: [common, configMixin],
  components: {
    LanguageSelector,
    MorphIcon,
    ResetAppDialog,
  },

  data() {
    return {
      resetAppDialogOpen: false,
      language: localStorage.getItem('lang'),
      timeFormats: [
        { text: this.$t('24_plus_hh_mm'), value: '24+hh:mm' },
        { text: this.$t('hh_mm'), value: 'hh:mm' },
      ],
      fontSizes: [
        { text: this.$t('normal'), value: 16 },
        { text: this.$t('greater'), value: 18 },
        { text: this.$t('large'), value: 20 },
      ],
    };
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
      stage: (state) => state.configs.stage,
      customerRelations: (state) => state.profile.customerRelations,
      tenant() {
        return this.customerRelations.tenant;
      },
    }),
    ...mapState('profile', ['userProfile']),
    dark: {
      // getter
      get() {
        return this.appliedThemeName === 'dark';
      },
      // setter
      set(newValue) {
        this.$vuetify.theme.dark = newValue;
        this.$store.commit('theme/switchTheme');
      },
    },
    timeFormatSetting: {
      get() {
        return this.$store.state.profile.userProfile.timeFormat;
      },
      set(newValue) {
        console.debug('set timeFormatSetting', newValue);
        let userProfile = this.$store.state.profile.userProfile;
        userProfile.timeFormat = newValue;
        this.$store.commit('profile/setUserProfile', userProfile);
      },
    },
    pdfViewer: {
      get() {
        return this.userProfile.pdfViewer || 'pdfjs';
      },
      set(value) {
        this.setPdfViewer(value);
      },
    },
    displayPdfChangeViewer: {
      get() {
        return this.userProfile.displayPdfChangeViewer;
      },
      set(value) {
        this.setDisplayPdfChangeViewer(value);
      },
    },
    displayPdfViewerHintMode: {
      get() {
        return this.userProfile.displayPdfViewerHintMode;
      },
      set(value) {
        this.setDisplayPdfViewerHintMode(value);
      },
    },
    baseFontSize: {
      get() {
        return this.$store.state.profile.userProfile.baseFontSize;
      },
      set(newValue) {
        console.debug('set baseFontSize', newValue);
        let userProfile = this.$store.state.profile.userProfile;
        userProfile.baseFontSize = newValue;
        var r = document.querySelector(':root');
        r.style.setProperty('--base-font-size', newValue + 'px');
        this.$store.commit('profile/setUserProfile', userProfile);
      },
    },
    appliedThemeName() {
      return this.$store.state.theme.appliedThemeName;
    },
  },
  methods: {
    ...mapMutations('profile', ['setPdfViewer', 'setDisplayPdfChangeViewer', 'setDisplayPdfViewerHintMode']),
    showChangePassword() {
      //this.$store.dispatch('lifecycle/setAppStates', { authenticated: false, configsLoaded: true }, { root: true });
      this.$store.dispatch('profile/logout', { onPasswordChange: true, user: this.$store.state.profile.user });
    },
    reload() {
      window.location.assign(configurations.webAppBaseUrl);
    },
  },
};
</script>
<style scoped>
.body--light .border-bottom {
}
</style>
